import DaisyComponent from './daisy.component';
import './../../layout/sidebar/index';
import './../../layout/content/index';
import './../../components/home/index';
import './../../components/transportauftrag/index';

angular
	.module('app.daisy', [
		'app.sidebar',
		'app.content',
		'app.home',
		'app.transportauftrag'
	])
	.component('appDaisy', DaisyComponent);
